import _isEqual from 'lodash/isEqual';

// eslint-disable-next-line import/prefer-default-export
export const setInititativeSettings = (organizationId, organizations) => {
  return organizations.find((i) => _isEqual(i.id, +organizationId))?.settings;
};

export const getOnlyPageBodyByInitiativeId = (id, initiatives) => initiatives.find((initiative) => String(initiative.id) === String(id))?.body_page_only;
